import { css } from '@emotion/css';
import { OfferOrderStatusLabel } from 'src/models';
import { Display, Font, FontWeight, Spacing } from 'src/styles';
import { getOfferOrderStatusTagColor } from 'src/utils';

export const tag = (transfer: OfferOrderStatusLabel) => {
  const schema = getOfferOrderStatusTagColor(transfer);

  return css`
    ${Font.lg}
    ${Display.flex}
    ${FontWeight.semibold}
    width: fit-content;
    ${Spacing.py4}
    ${Spacing.px8}
    border: 0.0625rem solid ${schema.background};
    border-radius: 0.5rem;
    color: ${schema.color};
    background-color: ${schema.background};
    height: 1.5rem;
  `;
};
